<script lang="jsx">
const DropDown = ({ id, label, items, value, disabled, update, default: _default, required = false, maxWidth = 'auto' }) => {
  const reqStar = required ? '*' : '';
    return [
      label && <label style={{"max-width": maxWidth}} for={id}>{label + ' ' + reqStar}:</label>,
      <div class="icon-input" style={{"max-width": maxWidth}}>
        <select
          id={id}
          value={value}
          onChange={e => update(e.target.value)}
          disabled={disabled}
          style={{"max-width": maxWidth}}
        >
          {_default &&
            (_default.unselectable ? (
              <option value="" selected disabled hidden>
                {_default.value}
              </option>
            ) : (
              <option value="" selected>
                {_default}
              </option>
            ))}
          {items.map(({ label, value, disabled }) => (
            <option key={value} value={value} disabled={disabled}>
              {label}
            </option>
          ))}
        </select>
        <chevron-down-icon />
      </div>
    ];
};
export default DropDown;
</script>